import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { IUseMapArgs, IUseMapHook } from './types';
import useMapAppleAdapter from './use-map-apple-adapter.web';
import useMapGoogle from './use-map-google.web';

/**
 * Main useMap hook that conditionally uses Apple MapKit or Google Maps
 * based on the ENABLE_APPLE_MAPKIT_WEB flag.
 *
 * Only one map provider is initialized at a time based on the flag value.
 */
const useMap: IUseMapHook = (args: IUseMapArgs = {}) => {
  const enabledAppleMapkit = useFlag(LaunchDarklyFlag.ENABLE_APPLE_MAPKIT_WEB);

  // Pass enabled flag to each hook so only the active one initializes the map
  const appleResult = useMapAppleAdapter(args, enabledAppleMapkit);
  const googleResult = useMapGoogle(args, !enabledAppleMapkit);

  return enabledAppleMapkit ? appleResult : googleResult;
};

export default useMap;
